import { logoutUser } from "store/actions"
import store from "../../index"

export default function UnAuthorized() {
  // localStorage.clear()
  store.dispatch(logoutUser())
}
